
//GET QUOTE CONSTS//

export const GET_QUOTE_HEADING = "Look Your Best At Your Wedding"
export const GET_QUOTE_SUBHEADING = "Find perfect partner for your bridal makeup"
export const DISCOVER_AND_BOOK ="Discover And Book From The Best"
export const GET_QUOTES_HEADER ="Find Perfect Venue for Your"
/** Single-line hero headline for get-quote LP (no rotating suffix). */
export const GET_QUOTES_HERO_HEADLINE = "Find Perfect Venue For Your Wedding"
export const GET_QUOTES_SUB_HEADING ="Search and Discover banquet halls, wedding lawns and corporate party halls to your exact budget and requirements"
export const GET_QUOTES_TYPICAL_TEXT_WEDDING = "Wedding"
export const GET_QUOTES_TYPICAL_TEXT_CORPORATE = "Corporate"
export const GET_QOTES_TYPICAL_TEXT_SOCIAL = "Social"


export const discoverandbook = [
    {icon:"vm_quote_review", heading: "Checkout Reviews and Stories", desc: "Shortlist & connect with those who match your requirements" },
    {icon:"vm_quote_call", heading: "Direct Connection", desc: "Get no-hindrance direct connect with the Vendor" },
    {icon:"vm_quote_manage",heading: "Guaranteed Service Quality", desc: "A dedicated Customer Support to help you with service quality or issues" }, 
];

export const carouselimage = [
    {icon:"https://vmnk.gumlet.io/get-quote-imageone.svg", id:1},
    {icon:"https://vmnk.gumlet.io/get-quote-imagesecond.svg", id: 2 },
    {icon:"https://vmnk.gumlet.io/get-quote-imagethird.svg",id: 3 }, 
    {icon:"https://vmnk.gumlet.io/get-quote-imagefourth.svg", id: 4 },
];

/** Corporate venue LPs: single hero background (no carousel). */
export const CORPORATE_HERO_STATIC_BG_URL =
  "https://vmnk.gumlet.io/get-quote-imagethird.svg";

export const corporateclienticon = [
    {icon:"https://vmnk.gumlet.io/corporate-client1.svg", id:1},
    {icon:"https://vmnk.gumlet.io/corporate-client-icon2.svg", id: 2 },
    {icon:"https://vmnk.gumlet.io/corporate-client-icon3.svg",id: 3 }, 
    {icon:"https://vmnk.gumlet.io/corporate-client-icon4.svg", id: 4 },
    {icon:"https://vmnk.gumlet.io/corporate-client-icon5.svg",id: 5 }, 
    {icon:"https://vmnk.gumlet.io/corporate-client-icon6.svg", id:6},
    {icon:"https://vmnk.gumlet.io/corporate-client-icon7.svg", id: 7 },
    {icon:"https://vmnk.gumlet.io/corporate-client-icon8.svg",id: 8 }, 
    {icon:"https://vmnk.gumlet.io/corporate-client-icon9.svg", id: 9 },
    {icon:"https://vmnk.gumlet.io/corporate-client-icon10.svg",id: 10 },
    {icon:"https://vmnk.gumlet.io/corporate-client-icon11.svg",id: 11 },

];

// export const carouselimage = [
//     {image:"vm_get_quote_carousel_image1", id:1},
//     {image:"vm_get_quote_carousel_image2", id: 2 },
//     {image:"vm_get_quote_carousel_image3",id: 3 }, 
//     {image:"vm_get_quote_carousel_image4", id: 4 },
//     {image:"vm_get_quote_carousel_image5",id: 5 }, 
// ];
export const EVEN_TRIGGER_CODE = 'even';
export const ODD_TRIGGER_CODE = 'odd';

export const NEW_LEAD_FORM_LEAD_SOURCE_DESKTOP = 'new-lead-form-lead-source-desktop';
export const NEW_LEAD_FORM_LEAD_SOURCE_MOBILE = 'new-lead-form-lead-source-mobile';
export const OLD_LEAD_FORM_LEAD_SOURCE_MOBILE = 'old-lead-form-lead-source-mobile';
export const OLD_LEAD_FORM_LEAD_SOURCE_DESKTOP = 'old-lead-form-lead-source-desktop';
export const FREE_FOOD_LEAD_FORM_LEAD_SOURCE_DESKTOP = 'free-food-lead-form-lead-source-desktop';
export const CONNECT_TO_VM_LEAD_FORM_LEAD_SOURCE_DESKTOP = 'connect-to-vm-lead-form-lead-source-desktop';

// export const VERSION_1_OLD_LEAD_FORM='v1-old-lead-form';
// export const VERSION_1_NEW_LEAD_FORM='v1-new-lead-form';
// export const MOBILE_FORM_POPUP='mobile-form-pop-up';
// // export const DESKTOP_FORM_POPUP='desktop-form-pop-up';
// export const AUTO='auto';
// export const USER='user';

export const VERSION_0_OLD_LEAD_FORM='v0-old-lead-form';
export const VERSION_1_OLD_LEAD_FORM='v1-old-lead-form';
export const VERSION_1_NEW_LEAD_FORM='v1-new-lead-form';
export const MOBILE_FORM_POPUP='mobile-form-pop-up';
export const DESKTOP_FORM_POPUP='desktop-form-pop-up';
export const AUTO='auto';
export const USER='user';
// export const OLD_LEAD_FORM_DESKTOP_FORM_POPUP_USER = `${VERSION_1_OLD_LEAD_FORM}/${DESKTOP_FORM_POPUP}/${USER}`;
// export const OLD_LEAD_FORM_DESKTOP_FORM_POPUP_AUTO = `${VERSION_1_OLD_LEAD_FORM}/${DESKTOP_FORM_POPUP}/${AUTO}`;
// export const NEW_LEAD_FORM_DESKTOP_FORM_POPUP_USER = `${VERSION_1_NEW_LEAD_FORM}/${DESKTOP_FORM_POPUP}/${USER}`;
// export const NEW_LEAD_FORM_DESKTOP_FORM_POPUP_AUTO = `${VERSION_1_NEW_LEAD_FORM}/${DESKTOP_FORM_POPUP}/${AUTO}`;

export const OLD_LEAD_FORM_MOBILE_FORM_POPUP_USER = `${VERSION_1_OLD_LEAD_FORM}/${MOBILE_FORM_POPUP}/${USER}`;
export const OLD_LEAD_FORM_MOBILE_FORM_POPUP_AUTO = `${VERSION_1_OLD_LEAD_FORM}/${MOBILE_FORM_POPUP}/${AUTO}`;
export const NEW_LEAD_FORM_MOBILE_FORM_POPUP_USER = `${VERSION_1_NEW_LEAD_FORM}/${MOBILE_FORM_POPUP}/${USER}`;
export const NEW_LEAD_FORM_MOBILE_FORM_POPUP_AUTO = `${VERSION_1_NEW_LEAD_FORM}/${MOBILE_FORM_POPUP}/${AUTO}`;

export const V0_OLD_LEAD_FORM_DESKTOP_FORM_POPUP_USER = `${VERSION_0_OLD_LEAD_FORM}/${DESKTOP_FORM_POPUP}/${USER}`;
export const V0_OLD_LEAD_FORM_DESKTOP_FORM_POPUP_AUTO = `${VERSION_0_OLD_LEAD_FORM}/${DESKTOP_FORM_POPUP}/${AUTO}`;
export const OLD_LEAD_FORM_DESKTOP_FORM_POPUP_USER = `${VERSION_1_OLD_LEAD_FORM}/${DESKTOP_FORM_POPUP}/${USER}`;
export const OLD_LEAD_FORM_DESKTOP_FORM_POPUP_AUTO = `${VERSION_1_OLD_LEAD_FORM}/${DESKTOP_FORM_POPUP}/${AUTO}`;
export const NEW_LEAD_FORM_DESKTOP_FORM_POPUP_USER = `${VERSION_1_NEW_LEAD_FORM}/${DESKTOP_FORM_POPUP}/${USER}`;
export const NEW_LEAD_FORM_DESKTOP_FORM_POPUP_AUTO = `${VERSION_1_NEW_LEAD_FORM}/${DESKTOP_FORM_POPUP}/${AUTO}`;

export const CATEGORY_WEDDING = "wedding";
export const CATEGORY_CORPORATE = "corporate";
export const CATEGORY_SOCIAL = "social";

export const leadFormOperatingCities = ['delhi', 'gurgaon', 'faridabad', 'ghaziabad', 'noida', 'jaipur', 'mumbai', 'pune', 'pushkar', 'alwar', 'palwal']

export const LEAD_FORM_EXIT_WINDOW_CONSTS = {
    cautionMessage: "You might miss out on savings worth upto",
    weddingMissingOutPrice: "1,00,000",
    social_corporate_missingOutPrice: "10,000",
    default_missingOutPrice: "10,000",
    warningMessage: "Are you sure you want to leave this page?",
    continueRequestCta: "Continue Request",
    closeRequestCta: "Close Request",
    continueUserEventName: "leadform-exit-window-close-click",
    closeUserEventName: "leadform-exit-window-continue-click",
}

export const OCCASION_SEARCH_PARAMS={
    Wedding : "wedding-venues",
    Corporate:"corporate-party-venues",
    Social:"party-venues"
}

export const VENUE_TOUR_TIME_SLOTS = [
    { value: "morning", label: "morning" },
    { value: "afternoon", label: "afternoon" },
    { value: "evening", label: "evening" },
  ]


export const VENUE_TOUR_HEADING = 'Get Venue Tour'  

export const SAYA_DATE_SUB_HEADING = "Book venue quickly!"
export const VENUE_PAGE_SAYA_DATE_SUB_HEADING = "a visit quickly!"
export const SAYA_DATE_HEADING = <>Saya dates are <span>Filling up</span> fast</>;
export const SAYA_DATE_BOOKING_SUB_HEADING = "Plan a Visit Now Hurry Up!"
export const VENUEPAGE_SAYA_DATE_BOOKING_SUB_HEADING = "a Visit Now Hurry Up!"
export const WE_DO_NOT_SPAM_TEXT = 'We don’t spam'  



// required keys in multikey enums 

const ALL = "all"
const ANY = "any"
const CUSTOM = "custom"